export default __webpack_public_path__ + "static/og_image-586d822e90317f6784a4c3e6a122c73c.webp";